// extracted by mini-css-extract-plugin
export default {"SearchContainer":"SearchResults_SearchContainer__bP0IT","NewsGrid":"SearchResults_NewsGrid__4ffsA","Pagination":"SearchResults_Pagination__f9bmN"};